<div fxLayout="row" fxLayoutAlign="start center" class="dismiss" (click)="snackBarRef.dismiss()">
    <div fxLayoutAlign="start center">
        <img class="icon-message" *ngIf="data.status === 'success'" src="assets/images/svg/icon-show-message-1.svg" alt="">
        <img class="icon-message" *ngIf="data.status === 'warring'" src="assets/images/svg/icon-show-message-2.svg" alt="">
        <img class="icon-message" *ngIf="data.status === 'error'" src="assets/images/svg/icon-show-message-3.svg" alt="">
    </div>
    &nbsp;&nbsp;&nbsp;
    <div id="message-snackbar" fxLayoutAlign="start center" [innerHTML]="data.message"></div>
</div>
